"use strict";
//
// Copyright © 2020 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadata = getMetadata;
exports.setMetadata = setMetadata;
exports.loadMetadata = loadMetadata;
const metadata = new Map();
/**
 * @public
 * @param id -
 * @returns
 */
function getMetadata(id) {
    return metadata.get(id);
}
/**
 * @public
 * @param id -
 * @param value -
 */
function setMetadata(id, value) {
    metadata.set(id, value);
}
/**
 * @public
 * @param ids -
 * @param data -
 */
function loadMetadata(ids, data) {
    for (const key in ids) {
        const id = ids[key];
        const resource = data[key];
        if (resource === undefined) {
            throw new Error(`no metadata provided, key: ${key}, id: ${String(id)}`);
        }
        metadata.set(id, resource);
    }
}
//# sourceMappingURL=metadata.js.map